import { Widget } from "@foretagsplatsen/widgetjs";
import LatexFormulaVisitor from "../../../models/keyFigure/formula/visitors/LatexFormulaVisitor.js";

/**
 * Formula widget is a widget that displays a typeset formula node using MathJax.
 *
 * @param {formulaNode} spec.formulaNode - Formula node
 * @param {boolean} [spec.useAnchors = true] - Whether visible KPIs are rendered
 * as links.
 * @param {Report} [report] - If the formula contains instances of
 * ReportReferenceFormulaNode, this variable is used to get the
 * referenced report item.
 * @param {dimension} [spec.dimensionTree] - Root dimension from which
 * dimension ids are resolved.
 */
export default class FormulaWidget extends Widget {
	constructor({
		formulaNode,
		useAnchors = true,
		report,
		dimensionTree,
	} = {}) {
		super(...arguments);
		this._formulaNode = formulaNode;
		this._useAnchors = useAnchors;
		this._report = report;
		this._dimensionTree = dimensionTree;
	}

	setFormula(formulaNode) {
		this._formulaNode = formulaNode;
		this.update();
	}

	renderContentOn(html) {
		if (!this._formulaNode) {
			html.div({ klass: "formula formula-empty" }, "-");
			return;
		}

		const formulaDiv = html
			.div(
				{
					style: "visibility: hidden;",
					klass: "formula",
				},
				new LatexFormulaVisitor({
					useAnchors: this._useAnchors,
					report: this._report,
					dimensionTree: this._dimensionTree,
				}).formula(this._formulaNode),
			)
			.asJQuery();

		MathJax.typesetPromise(formulaDiv).then(() =>
			formulaDiv.css("visibility", "visible"),
		);
	}
}
